import React from 'react';
import {
  SvgContainer,
  SvgContainerProps
} from '@/components/icon/SvgContainer';
import { styled } from '@mui/material/styles';

const MedicalScoreIconBase = (props: SvgContainerProps) => (
  <SvgContainer {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4.5v15m7.5-7.5h-15"
    />
  </SvgContainer>
);

export const MedicalScoreIcon = styled(MedicalScoreIconBase)`
  margin-right: -4px;
  opacity: 0.66;
  stroke: currentColor;
  stroke-width: 4px;
  width: 16px;
  height: 16px;
`;
